import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { FloatingTextViewImpl } from './floatingtextview';
import { FloatingTextCSSStyleImpl } from './floatingtextcss';

export interface FloatingTextComponentProps extends UIComponentProps
{
    id: string;
    value: string;
    placeholder: string;
    isDisabled?:boolean;
    maxLength: string;
    inputType: string;
    isRequired: boolean;
    emptyErrorMsg: string;
}

export interface FloatingTextComponentState extends UIComponentState
{
    value: string;
    errorMessage: undefined | string;
    class: string;
}

export interface FloatingTextComponentHandler extends UIComponentHandler
{
    onChange(data: string): void;
}

export class FloatingTextComponent extends UIComponentImpl<FloatingTextComponentProps, FloatingTextComponentState, UIDataModel> 
       implements FloatingTextComponentHandler
{
    constructor(props: FloatingTextComponentProps)
    {
        super(props);

        this.state = {value: props.value, errorMessage: undefined, 
            class: props.value === " " || props.value === "" ? "" : "on"};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FloatingTextViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new FloatingTextCSSStyleImpl(applicationContext);
    }

    setErrorMessage(errorMesssage: string)
    {
        this.setState({errorMessage: errorMesssage});
    }

    UNSAFE_componentWillReceiveProps(newProps:FloatingTextComponentProps)
    {
        this.setState({value: newProps.value});
    }

    onChange(data: string): void 
    {
       
        if (data !== '') {
            this.setState({value: data.slice(0, +this.props.maxLength)}, ()=>
            {
                this.setState({class: "on"});
            });
        }
        else {
                this.setState({value: data.slice(0, +this.props.maxLength)}, ()=>
                    {
                        this.setState({class: "on"});
                    });
        }
    }

    getData(): string
    {
        return this.state.value;
    }

    clearData()
    {
        this.setState({value: "", errorMessage: undefined});
    }

    validate(): boolean
    {
        if(this.props.isRequired && this.state.value.length === 0)
        {
            this.setState({errorMessage: this.props.emptyErrorMsg});

            return false;
        }
        else
        {
            this.setState({errorMessage: undefined});

            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/floatingtext/floatingtextcomponent.tsx